import { useMemo } from 'react';

type UseCharCountProps = {
  showCount?: boolean;
  softLimit?: number;
  maxLength?: number;
  countDisplayThreshold?: number;
  value?: string | number | readonly string[];
};

const useCharCount = ({
  showCount,
  softLimit,
  maxLength,
  countDisplayThreshold,
  value,
}: UseCharCountProps) => {
  const charCount = useMemo(() => {
    if (value === undefined || value === null) return 0;
    return typeof value === 'number' ? String(value).length : value.length;
  }, [value]);

  const limit = showCount !== false && (softLimit || maxLength);
  const shouldRenderCount =
    limit &&
    (!countDisplayThreshold ||
      (countDisplayThreshold && limit - charCount <= countDisplayThreshold));

  return { charCount, shouldRenderCount };
};

export default useCharCount;
